exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2Co7R{background:#f3d8d8}.f6NZ6{background:#bce0bc}.bsHWL{background:#fff}._3-cys{padding:0!important}.sZ8KW{padding:7px 3px}._1OzCm div{overflow-x:hidden!important}._1OzCm div div div div{overflow:hidden!important}", ""]);

// exports
exports.locals = {
	"pendiente": "_2Co7R",
	"procesada": "f6NZ6",
	"normal": "bsHWL",
	"tdClear": "_3-cys",
	"field": "sZ8KW",
	"hidden": "_1OzCm"
};